import { RouterFeatures, withDisabledInitialNavigation, withInMemoryScrolling } from '@angular/router';

export const commonRouterFeatures: RouterFeatures[] = [
  withDisabledInitialNavigation(),
  withInMemoryScrolling({ scrollPositionRestoration: 'top', anchorScrolling: 'disabled' })
];
